import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChatService } from '../../../services';
import { PdfViewerService } from '../../../services/pdfViewer';

interface Comment {
  messageId?: string;
  messageBody?: string;
  parentMessageId?: string;
  createdByOrganizationId?: string;
  allowContractorToRespond?: boolean;
  contractorResponded?: boolean;
  documentMetadata: any;
  dateCreated?: string;
  createdBy?: string;
  complaintId?: string;
  resolvedPath?: string;
  level?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  organizationShortName?: string;
  organizationLongName?: string;
  logoPath?: string;
  organizationTypeId?: string;
  fileName: string;
  filePath: string;
  fileDescription: string;
  extension: string;
  extensionGroup: string;
  appUserImage?: string;
  currentComplaintApprovalMonitoring?: any;
  parentCommentId: string;
}

@Component({
  selector: 'app-chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.scss'],
})
export class ChatMessagesComponent implements OnInit {
  @Input() typing: boolean = false;

  @Input() equipment: any;
  @Input() parentId: string;
  @Input() objectId: string;
  @Input() msg: Comment;
  @Input() objectType: string;
  @Input() isReply: boolean;
  @Output() reply: EventEmitter<any> = new EventEmitter();
  @Output() onApproval: EventEmitter<any> = new EventEmitter();
  successMessage;
  messageIndex;
  collapse: boolean = true;
  replyBlock;
  success: boolean;
  error: any;
  organization: any;
  user: any;
  organizationId: string;
  messages: Array<any>;
  pending: boolean;
  total;
  page;
  records;

  replyForm: FormGroup;
  messageParams: AppFilter;
  searchMessagesFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'objectId',
        op: 'eq',
        data: '',
      },
    ],
  };

  baseUrl;
  appUserImage: any;
  currentUserName;
  private unsubscribe$: Subject<void> = new Subject<void>();
  secureDocumentUrl;
  constructor(
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private router: Router,
    private pdfViewerService: PdfViewerService
  ) {
    this.messageParams = new AppFilter({
      sidx: 'dateCreated',
      rows: 15,
      sord: 'desc',
    });
    this.baseUrl = environment.API_SERVER;
    this.replyForm = fb.group({
      comment: ['', Validators.required],
      equipmentName: [''],
      to: [''],
      documentId: [''],
    });

    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = this.user['organizationId'];
    if (this.user && this.user.image) {
      this.user.image = `${
        this.baseUrl
      }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.user.image = 'assets/avatar/1.jpg';
    }
    this.currentUserName = `${this.user.firstName} ${this.user.lastName} ${this.user.middleName}`;
    this.user.username = this.currentUserName.trim();
  }
  ngOnInit() {}

  dataToJSON(data: any) {
    try {
      JSON.parse(data);
    } catch (e) {
      return data;
    }
    return JSON.parse(data);
  }
  sanitize(string) {
    let data = this.sanitizer.bypassSecurityTrustHtml(string);
    return data;
  }
  onCollapse() {
    this.collapse = !this.collapse;
  }
  onReply(event) {
    // this.replyForm.get('messageBody').patchValue('Reply to comment');
    this.isReply = event;
  }
  showReplyForm(form) {
    this.reply.emit(form);
  }
  loadImage(path) {
    return `${this.baseUrl}/public/image/?media=${JSON.parse(
      path
    ).image.replace(/\\/g, '/')}`;
  }
  loadOrganizationImage(path) {
    return `${this.baseUrl}/public/image/?media=${
      JSON.parse(path).organizationLogo
    }`;
  }
  viewDoc(msg) {
    let url = `${this.baseUrl}/public/image/?media=${msg.documentId}`;
  }
  uploadDoc() {}

  viewDocument(documentData: any) {
    this.pdfViewerService.viewPdf(documentData);
  }

  checkDocType(documentData: any): string {
    if (documentData.documentPath.includes('png' || 'jpg' || 'jpeg')) {
      return 'image';
    } else return 'file';
  }

  ngOnDestroy() {}
  getCreatedBy(msg: any): string {
    const metadata = this.dataToJSON(msg.parentCommentMetadata);
    return metadata ? metadata.createdBy : 'NCC Representative';
  }
}
